import ApiService from "../../../services/ApiService";

const BASE = "/v1/puzzle-coins";

function buildSort(sort) {
    if (!Array.isArray(sort) || sort.length === 0) return "earnedAt:desc";
    return sort.map((s) => `${s.field}:${s.sort}`).join(",");
}

function totalElements(result) {
    if (!result || typeof result !== "object") return 0;
    return result.totalElements ?? result.page?.totalElements ?? 0;
}

/** Jigsaw difficulty is the tile size. Extra catalog pairs are not real rules. */
const JIGSAW_DIFFICULTY_BY_TILE = {
    6: "EASY",
    9: "MEDIUM",
    12: "HARD",
    16: "PRO",
    24: "ELITE",
    32: "INSANE",
};

/** Flattens catalog maps into grid rows for sliding and jigsaw. */
function parseCatalog(raw) {
    const slidingRows = [];
    const jigsawRows = [];

    const sliding = raw?.sliding && typeof raw.sliding === "object" ? raw.sliding : {};
    Object.entries(sliding).forEach(([gridSize, difficulties]) => {
        if (!difficulties || typeof difficulties !== "object") return;
        Object.entries(difficulties).forEach(([difficulty, coins]) => {
            slidingRows.push({
                id: `sliding-${gridSize}-${difficulty}`,
                puzzleType: "SLIDING",
                size: gridSize,
                difficulty,
                coins: Number(coins) || 0,
            });
        });
    });

    const jigsaw = raw?.jigsaw && typeof raw.jigsaw === "object" ? raw.jigsaw : {};
    Object.entries(jigsaw).forEach(([tileSize, difficulties]) => {
        if (!difficulties || typeof difficulties !== "object") return;
        const expected = JIGSAW_DIFFICULTY_BY_TILE[Number(tileSize)];
        if (!expected) return;
        const coins = difficulties[expected];
        if (coins == null) return;
        jigsawRows.push({
            id: `jigsaw-${tileSize}-${expected}`,
            puzzleType: "JIGSAW",
            size: tileSize,
            difficulty: expected,
            coins: Number(coins) || 0,
        });
    });

    return { slidingRows, jigsawRows };
}

const PuzzleCoinsService = {
    listCoins: async (paginationModel, sort, { userId = "", puzzleType = "" } = {}) => {
        const params = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sort: buildSort(sort),
        };
        if (userId) params.userId = userId;
        if (puzzleType) params.puzzleType = puzzleType;
        return ApiService.getData(BASE, params);
    },

    getById: async (id) => ApiService.getData(`${BASE}/${id}`),

    getUserTotal: async (userId) => ApiService.getData(`${BASE}/user/${userId}/total`),

    getCatalog: async () => ApiService.getData(`${BASE}/catalog`),

    grantCoins: async ({ userId, puzzleType, targetCoins }) =>
        ApiService.putData(`${BASE}/grant`, {
            userId,
            puzzleType,
            targetCoins: Number(targetCoins),
        }),

    parseCatalog,

    totalElements,
};

export default PuzzleCoinsService;
